const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-redactor/:uid",
    meta: {},
    name: "m-redactor",
    component: () => import("@/modules/redactor/RootView.vue"),
    children: [
        {
            path: "/m-redactor/",
            meta: {},
            name: "m-redactor-home",
            component: () => import("../views/Home.vue")
        },
        {
            path: "/m-redactor/ad-settings",
            meta: {},
            name: "m-redactor-ad-settings",
            component: () => import("../views/ad-settings/r-ad-settings-page.vue")
        },
        {
            path: "/m-redactor/avatars",
            meta: {},
            name: "m-redactor-avatars",
            component: () => import("../views/avatar/r-avatar-page.vue")
        },
        {
            path: "/m-redactor/map-addon",
            meta: {},
            name: "m-redactor-map-addon",
            component: () => import("../views/map-addon/r-map-addon-config-page.vue")
        },
        {
            path: "/m-redactor/cards",
            meta: {},
            name: "m-redactor-cards",
            component: () => import("../views/card/r-card-page.vue")
        },
        {
            path: "/m-redactor/card-clusters",
            meta: {},
            name: "m-redactor-card-clusters",
            component: () => import("../views/card-cluster/r-card-cluster-page.vue")
        },
        {
            path: "/m-redactor/card-packages",
            meta: {},
            name: "m-redactor-card-packages",
            component: () => import("../views/card-package/r-card-package-page.vue")
        },

        {
            path: "/m-redactor/boosters",
            meta: {},
            name: "m-redactor-boosters",
            component: () => import("../views/booster/r-booster-page.vue")
        },
        {
            path: "/m-redactor/product-items",
            meta: {},
            name: "m-redactor-product-items",
            component: () => import("../views/product/r-product-page.vue")
        },
        {
            path: "/m-redactor/product-groups",
            meta: {},
            name: "m-redactor-product-groups",
            component: () => import("../views/product-group/r-product-group-page.vue")
        },


        {
            path: "/m-redactor/trader",
            meta: {},
            name: "m-redactor-trader",
            component: () => import("../views/trader/r-trader-page.vue")
        },
        {
            path: "/m-redactor/currencies",
            meta: {},
            name: "m-redactor-currencies-holder",
            component: () => import("../views/currency/r-currencies-holder-page.vue")
        },
        {
            path: "/m-redactor/reward-packages",
            meta: {},
            name: "m-redactor-reward-packages",
            component: () => import("../views/reward-pack/r-reward-package-page.vue")
        },
        {
            path: "/m-redactor/recipes",
            meta: {},
            name: "m-redactor-recipes",
            component: () => import("../views/recipe/r-recipe-page.vue")
        },
        {
            path: "/m-redactor/prompts",
            meta: {},
            name: "m-redactor-prompts",
            component: () => import("../views/prompt/r-prompt-page.vue")
        },
        {
            path: "/m-redactor/settings",
            meta: {},
            name: "m-redactor-settings",
            component: () => import("../views/settings/r-settings-page.vue")
        },
        {
            path: "/m-redactor/exchange",
            meta: {},
            name: "m-redactor-exchange",
            component: () => import("../views/exchange/r-exchange-page.vue")
        },

        {
            path: "/m-redactor/quests",
            meta: {},
            name: "m-redactor-quests",
            component: () => import("../views/quest/r-quest-page.vue")
        },
        {
            path: "/m-redactor/boats",
            meta: {},
            name: "m-redactor-boats",
            component: () => import("../views/boats/r-boat-page.vue")
        },
        {
          path: "/m-redactor/server-events",
          meta: {},
          name: "m-redactor-server-events",
          component: () => import("../views/server-events/r-server-events-page.vue")
        },
        {
            path: "/m-redactor/discoveries",
            meta: {},
            name: "m-redactor-discoveries",
            component: () => import("../views/discovery/r-discovery-page.vue")
        },
        {
            path: "/m-redactor/fireflies",
            meta: {},
            name: "m-redactor-fireflies",
            component: () => import("../views/firefly/r-firefly-page.vue")
        },
        {
            path: "/m-redactor/fireflies-v2",
            meta: {},
            name: "m-redactor-fireflies-v2",
            component: () => import("../views/firefly/r-firefly-v2-page.vue")
        },
        {
            path: "/m-redactor/levels",
            meta: {},
            name: "m-redactor-levels",
            component: () => import("../views/level/r-level-page.vue")
        },
        {
            path: "/m-redactor/map-kind",
            meta: {},
            name: "m-redactor-map-kind",
            component: () => import("../views/map-kind/r-map-kind-page.vue")
        },
        {
            path: "/m-redactor/worker-kind",
            meta: {},
            name: "m-redactor-worker-kind",
            component: () => import("../views/worker-kind/r-worker-kind-page.vue")
        },
        {
            path: "/m-redactor/map-group",
            meta: {},
            name: "m-redactor-map-group",
            component: () => import("../views/map-group/r-map-group-page.vue")
        },
        {
            path: "/m-redactor/talks",
            meta: {},
            name: "m-redactor-talks",
            component: () => import("../views/talk/r-talk-page.vue")
        },
        {
            path: "/m-redactor/tutorials",
            meta: {},
            name: "m-redactor-tutorials",
            component: () => import("../views/tutorial/r-tutorial-page.vue")
        },
        {
            path: "/m-redactor/items",
            meta: {},
            name: "m-redactor-items-holder",
            component: () => import("../views/item/r-items-holder-page.vue")
        },
        {
            path: "/m-redactor/smart-offers",
            meta: {},
            name: "m-redactor-smart-offers",
            component: () => import("../views/smart-offer/r-smart-offer-page.vue")
        },
        {
            path: "/m-redactor/daily-quest",
            meta: {},
            name: "m-redactor-daily-quest",
            component: () => import("../views/daily-quest/r-daily-quest-page.vue")
        },
        {
            path: "/m-redactor/daily-bonus",
            meta: {},
            name: "m-redactor-daily-bonus",
            component: () => import("../views/daily-bonus/r-daily-bonus-page.vue")
        },
        {
            path: "/m-redactor/world-regions",
            meta: {},
            name: "m-redactor-world-regions",
            component: () => import("../views/world-region/r-world-region-page")
        },
        {
            path: "/m-redactor/world-region-territories",
            meta: {},
            name: "m-redactor-world-region-territories",
            component: () => import("../views/world-region-territory/r-world-region-territory-page")
        },
        {
            path: "/m-redactor/swamps",
            meta: {},
            name: "m-redactor-swamps",
            component: () => import("../views/world-biomes/swamp/r-swamp-page")
        },
        {
            path: "/m-redactor/worker-teams",
            meta: {},
            name: "m-redactor-worker-teams",
            component: () => import("../views/worker/r-worker-team-page")
        }
    ]
});

export default Routes;
